module.exports = __webpack_public_path__ + "img/ResidentSupervise3.6c8e3ba0.png";